import { call, put, takeEvery } from 'redux-saga/effects'
import {
  // Get Admin Services,
  getServiceListApiData,
  getServiceListApiSuccess,
  getServiceListApiFailed,
  // Get Admin Services  Details
  getServiceDetailsApiData,
  getServiceDetailsApiSuccess,
  getServiceDetailsApiFailed,

  // Post Admin Services
  addServiceApiData,
  addServiceApiSuccess,
  addServiceApiFailed,

  // Update Admin Services
  updateServiceApiData,
  updateServiceApiSuccess,
  updateServiceApiFailed,
  // Delete Admin services
  deleteServiceApiData,
  deleteServiceApiSuccess,
  deleteServiceApiFailed,
  // Active Inactive Service
  activeInactiveStoreServicesListApiData,
  activeInactiveStoreServicesListApiSuccess,
  activeInactiveStoreServicesListApiFailed,
} from './slice'

import { API } from '../../services'

function* getServiceListApi({ payload }) {
  try {
    const response = yield call(API.ServiceManagement.getServiceList, payload)
    if (response.data && response.status === 200) {
      yield put(getServiceListApiSuccess(response.data))
    } else {
      yield put(getServiceListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getServiceListApiFailed({ message: error.message }))
  }
}
function* getServiceDetailsApi({ payload }) {
  try {
    const response = yield call(API.ServiceManagement.getServiceDetails, payload)
    if (response.data && response.status === 200) {
      yield put(getServiceDetailsApiSuccess(response.data))
    } else {
      yield put(getServiceDetailsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getServiceDetailsApiFailed({ message: error.message }))
  }
}
function* addServiceApi({ payload }) {
  try {
    const response = yield call(API.ServiceManagement.addService, payload)
    if (response.data && response.status === 200) {
      yield put(addServiceApiSuccess(response.data))
    } else {
      yield put(addServiceApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addServiceApiFailed({ message: error.message }))
  }
}
function* updateServiceApi({ payload }) {
  try {
    const response = yield call(API.ServiceManagement.updateService, payload)
    if (response.data && response.status === 200) {
      yield put(updateServiceApiSuccess(response.data))
    } else {
      yield put(updateServiceApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateServiceApiFailed({ message: error.message }))
  }
}
function* deleteServiceApi({ payload }) {
  try {
    const response = yield call(API.ServiceManagement.deleteService, payload)
    if (response.data && response.status === 200) {
      yield put(deleteServiceApiSuccess(response.data))
    } else {
      yield put(deleteServiceApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteServiceApiFailed({ message: error.message }))
  }
}
function* activeInactiveStoreServicesListApi({ type, payload }) {
  try {
    const response = yield call(API.ServiceManagement.activeInactiveStoreServicesList, payload)
    if (response.data && response.status === 200) {
      yield put(activeInactiveStoreServicesListApiSuccess({ payload: response?.data }))
    } else {
      yield put(activeInactiveStoreServicesListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(activeInactiveStoreServicesListApiFailed({ message: error?.message }))
  }
}

export default function* adminServiceSaga() {
  yield takeEvery(getServiceListApiData.type, getServiceListApi)
  yield takeEvery(getServiceDetailsApiData.type, getServiceDetailsApi)
  yield takeEvery(addServiceApiData.type, addServiceApi)
  yield takeEvery(updateServiceApiData.type, updateServiceApi)
  yield takeEvery(deleteServiceApiData.type, deleteServiceApi)
  yield takeEvery(activeInactiveStoreServicesListApiData.type, activeInactiveStoreServicesListApi)
}
